module.exports = __webpack_public_path__ + "static/media/employee_db.52ee1eea.png";